import React from 'react';
import { Box, Typography } from '@mui/material';
import { SubmittedBadge, labelStyle } from './ClosestNumber.game';
import { Player } from '../../../types';

interface Props {
  players: Player[];
  currentPlayerId: string;
  submitted: boolean;
  onSubmit: (answer: string) => void;
}

const VoteBoost: React.FC<Props> = ({ players, currentPlayerId, submitted, onSubmit }) => {
  const others = players.filter(p => p.id !== currentPlayerId);

  if (submitted) return <SubmittedBadge label="Vote cast!" />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: '100%', maxWidth: 400 }}>
      <Typography sx={labelStyle}>Vote for the player you want to protect!</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, justifyContent: 'center', width: '100%' }}>
        {others.map(p => (
          <Box
            key={p.id}
            onClick={() => onSubmit(p.id)}
            sx={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5,
              background: 'rgba(255,255,255,0.15)', border: '3px solid rgba(255,255,255,0.3)',
              borderRadius: '16px', px: 2.5, py: 1.5,
              cursor: 'pointer', userSelect: 'none',
              transition: 'all 0.15s',
              '&:hover': { background: 'rgba(255,255,255,0.3)', transform: 'translateY(-4px)', borderColor: '#FFD700' },
            }}
          >
            <Typography sx={{ fontSize: '2rem', lineHeight: 1 }}>
              {p.avatarType === 'bundled' ? p.avatar : '🎮'}
            </Typography>
            <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', fontWeight: 'bold', color: 'white', fontSize: '0.85rem' }}>
              {p.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default VoteBoost;
